import React from 'react';
import NavbarDesktop from 'components/Navbar/NavbarDesktop';

const NavbarMenu = ({ closeDrawer }) => {
  return (
    <NavbarDesktop showMenu onClick={closeDrawer} />
  );
};

export default NavbarMenu;
